<script>
import StatusDelivery from "@/components/ordering/details/StatusDelivery.vue";

export default {
  name: 'ItemOrder',
  components: {StatusDelivery},
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      apiUrl: process.env.VUE_APP_API_URL
    }
  },
  computed: {
    formatDate () {
      const date = new Date(this.order.orderAt)
      return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1)
          .toString()
          .padStart(2, '0')}/${date.getFullYear()}`
    },
    getPrice () {
      return this.order.productsCart.reduce((sum, product) => {
        return sum + product.products.price * product.quantity
      }, 0)
    },
  }
}
</script>

<template>
  <div class="flex flex-wrap items-center gap-y-4 py-6">
    <dl class="w-1/2 sm:w-1/4 lg:w-auto lg:flex-1">
      <dt class="text-base font-medium text-gray-500 dark:text-gray-400">Numéro de commande:</dt>
      <dd class="mt-1.5 text-base font-semibold text-gray-900 dark:text-white">
        <router-link :to="{name: 'app_order_detail', params: {id: order.id}}" class="hover:underline">#{{ order.numberOrder }}</router-link>
      </dd>
    </dl>

    <dl class="w-1/3 sm:w-1/5 lg:w-auto lg:flex-1">
      <dt class="text-base font-medium text-gray-500 dark:text-gray-400">Date:</dt>
      <dd class="mt-1.5 text-base font-semibold text-gray-900 dark:text-white">
        {{ formatDate }}
      </dd>
    </dl>

    <dl class="w-1/3 sm:w-1/5 lg:w-auto lg:flex-1">
      <dt class="text-base font-medium text-gray-500 dark:text-gray-400">Prix:</dt>
      <dd class="mt-1.5 text-base font-semibold text-gray-900 dark:text-white">
        {{ getPrice }}€
      </dd>
    </dl>
    <status-delivery :workflows="order.Workflow" />

    <dl class="w-full sm:w-1/5 lg:w-auto flex items-center justify-end gap-4">
      <a :href="apiUrl +'/pdf/bon-de-commande/' + order.id" target="_blank" class="w-full rounded-lg px-3 py-2 text-center text-sm font-medium text-white bg-primary-700 hover:bg-primary-800 lg:w-auto">
        Facture
      </a>
      <router-link :to="{name: 'app_order_detail', params: {id: order.id}}" class="w-full inline-flex justify-center rounded-lg  border border-primary-700 bg-white px-3 py-2 text-sm font-medium text-primary-700 hover:bg-gray-100 hover:text-primary-700 lg:w-auto">
        Suivie commande
      </router-link>
    </dl>
  </div>
</template>
